import * as React from "react";
import {ProGroupIcon} from "@/agentur/AgenturIcons";
import {useTheme} from "@mui/material/styles";
import {EditNoteOutlined} from "@mui/icons-material";

export interface GradeStatusIndicatorProps {
    importedAt?: string | null;
    size?: "small" | "medium" | "large";
}

export const GradeStatusIndicator: React.FC<GradeStatusIndicatorProps> = ({ importedAt, size = "medium" }) => {
    const { palette } = useTheme();

    // Determine size values based on the size prop
    const getSize = () => {
        switch (size) {
            case "small":
                return { imgHeight: "16px", fontSize: "14px" };
            case "large":
                return { imgHeight: "24px", fontSize: "18px" };
            case "medium":
            default:
                return { imgHeight: "20px", fontSize: "16px" };
        }
    };

    const { imgHeight } = getSize();

    return (
        // <Box
        //     sx={{
        //         display: "flex",
        //         alignItems: "center",
        //         justifyContent: "center",
        //         marginLeft: 1,
        //         marginRight: 1
        //     }}
        // >
        importedAt ? (
            <ProGroupIcon
                style={{
                    height: imgHeight,
                    width: "auto",
                    paddingRight: 8
                }}
                fill={palette.text.primary}
            />
        ) : (
            <EditNoteOutlined style={{}} />
        )
        // </Box>
    );
};
